import { useMemo } from "react";

import type { SourceResource } from "@prequel/import-react";
import { useListSources } from "@prequel/import-react";
import type { TableRow } from "@prequel/shared-components";

import { useAllProviders } from "@/api/import/providers";
import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";
import { getVendorLabel } from "@/pages/import/vendors";

const COLUMNS = ["Name", "Vendor", "Provider", "Created"];

const SourcesTable = () => {
  const { items: providers } = useAllProviders();

  const providersByID = useMemo(() => new Map(providers.map((provider) => [provider.id, provider])), [providers]);

  const rowMapper = (source: SourceResource): TableRow => ({
    id: source.id,
    to: `/import/sources/${source.id}`,
    cells: [
      { value: source.name },
      { value: getVendorLabel(source.vendor) },
      { value: providersByID.get(source.provider_id)?.name ?? "-" },
      { value: <Timestamp timestamp={source.created_at} /> },
    ],
  });

  return (
    <ResourceTable<SourceResource>
      columns={COLUMNS}
      useQuery={useListSources}
      rowMapper={rowMapper}
      emptyMessage="No sources configured."
    />
  );
};

export default SourcesTable;
